import React, { useState } from "react";
import Sidebar from "../../components/Navigation/Sidebar";
import Topbar from "../../components/Navigation/Topbar";

// TODO: once we add a splashscreen we can remove this
window.onbeforeunload = function () {
  sessionStorage.removeItem("filter");
};

const DashboardLayout = (props) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const closeSidebar = () => setShowSidebar(false);

  return (
    <>
      <div id="wrapper" className={"dashboard"}>
        {showSidebar && (
          <div
            className="sidebar-backdrop d-md-none"
            onClick={() => setShowSidebar(false)}
          />
        )}
        <Sidebar
          className={showSidebar ? "show" : ""}
          onNavigate={closeSidebar}
        />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar clickMenuOpen={() => setShowSidebar(!showSidebar)} />
            <div className="dashboard-page-content">{props.children}</div>
          </div>
        </div>
      </div>
      <a className="scroll-to-top rounded" href="#">
        <i className="fas fa-angle-up"></i>
      </a>
    </>
  );
};

export default DashboardLayout;
